import axios from 'axios';
import { API_ROOT, invalidatePublicData } from '@/data/runtimeApi';

const BASE = `${API_ROOT}/admin`;
const TOKEN_KEY = 'link_admin_token';

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; }
};
export const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {}
};

export const adminApi = axios.create({
  baseURL: BASE,
  timeout: 30_000,
  headers: {
    Accept: 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
  },
});
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use((response) => {
  const method = String(response?.config?.method || 'get').toLowerCase();
  if (!['get', 'head', 'options'].includes(method)) {
    invalidatePublicData();
  }
  return response;
});

export async function loginAdmin(username, password) {
  const { data } = await adminApi.post('/login', { username, password });
  if (data?.token) setToken(data.token);
  return data;
}

export async function verifyAdmin() {
  try {
    const { data } = await adminApi.get('/verify');
    return data?.valid === true;
  } catch { return false; }
}

export function logoutAdmin() { setToken(''); }
